var map = {
	"./clear-day.svg": 555,
	"./clear-night.svg": 556,
	"./cloud-1-day.svg": 557,
	"./cloud-1-night.svg": 558,
	"./cloud-2-day.svg": 559,
	"./cloud-2-night.svg": 560,
	"./cloud-3-day.svg": 561,
	"./cloud-3-night.svg": 562,
	"./cloud-4-day.svg": 563,
	"./cloud-4-night.svg": 564,
	"./rain-1-day.svg": 565,
	"./rain-1-night.svg": 566,
	"./rain-2-day.svg": 567,
	"./rain-2-night.svg": 568,
	"./rain-3-day.svg": 569,
	"./rain-3-night.svg": 570,
	"./rain-4-day.svg": 571,
	"./rain-4-night.svg": 572,
	"./snow-1-day.svg": 573,
	"./snow-1-night.svg": 574,
	"./snow-2-day.svg": 575,
	"./snow-2-night.svg": 576,
	"./snow-3-day.svg": 577,
	"./snow-3-night.svg": 578,
	"./snow-4-day.svg": 579,
	"./snow-4-night.svg": 580,
	"./storm.svg": 581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 554;